import { useEffect, useState } from 'react';

/**
 * Reads OAuth error params from the current URL (search + hash) and
 * returns a human-readable string if any are present. Strips the params
 * after reading so the error doesn't stick to the URL on reload.
 *
 * Supabase + Google return errors via:
 *   - `?error=...&error_description=...`  (Supabase fallback)
 *   - `#error=...&error_description=...`  (implicit OAuth flow)
 */
export function useUrlAuthError(): string | null {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(
      window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash,
    );
    const code = search.get('error') ?? hash.get('error');
    const desc = search.get('error_description') ?? hash.get('error_description');
    if (code || desc) {
      setError(desc?.replaceAll('+', ' ') ?? code ?? 'unknown_error');
      // Strip the params so the toast doesn't re-fire on refresh.
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }, []);

  return error;
}
